<div class="py-4 px-2" style="padding-bottom: 50px !important" >
  <div class="pb-1">
    <h2 *ngIf="mode.toString() == 'createMode' || mode == 1">Create Well</h2>
    <h2 *ngIf="mode.toString() == 'editMode' || mode == 0">Edit Well Timeline</h2>
  </div>
  <div class="text-center">
    <div *ngIf="message" class="{{addWellAlertClass}} | sanitize" role="alert" id="addWellMessageBox">
      <strong>Attention!</strong> {{message}}
    </div>
    <div [hidden]="checkMode('createMode') || !past30Days" class="pull-left alert alert-info" role="alert">
      <p>The current Timeline entry for this well is older than 30 days, therefore changes cannot be made through the Control Panel. Please contact <a href="mailto:support@mi4.com">support&#64;mi4.com</a> if the Timeline edits need to go back more than 30 days. </p>
    </div>
  </div>

    <div class="d-flex justify-content-between flex-wrap-reverse pt-1 row">
      <div class="md-dropdown pb-2 col-12 col-md-6 col-xl-4">
        <p-dropdown *ngIf="mode.toString() == 'createMode' || mode == 1" #dd [options]="dropdownOptions" [(ngModel)]="cloneSelection" (onChange)="copyWellSelected($event.value)" [filter]="true" filterBy="label,value" placeholder="Select a well to clone" class="w-25"></p-dropdown>
        <ng-container *ngIf="loadingWells">
          <span role="status" class="spinner-border spinner-border-sm"></span>
        </ng-container>
      </div>
      <div class="col-12 pb-2 col-md-4 text-right">
        <button type="button" [disabled]="past30Days" class="btn btn-outline-warning" style="margin-right:10px;margin-bottom:10px;" (click)="resetConfirm(null)">Reset Form</button>
      </div>
    </div>
      <ul class="nav nav-tabs topBuffer10">
        <li class="active nav-item">
          <a class=" nav-link active" href="#basic" data-toggle="tab" role="tab" aria-controls="basic" aria-selected="true">Basic <span *ngIf="mode.toString() == 'createMode' || mode == 1" class="text-danger">* </span></a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#reg" data-toggle="tab" role="tab" aria-controls="reg" aria-selected="false">Regulatory</a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#gas" data-toggle="tab" role="tab" aria-controls="gas" aria-selected="false">Gas</a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#swd" data-toggle="tab" role="tab" aria-controls="swd" aria-selected="false">SWD</a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#completion" data-toggle="tab" role="tab" aria-controls="completion" aria-selected="false">Completion</a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#interests" data-toggle="tab" role="tab" aria-controls="interests" aria-selected="false">Interests</a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#land" data-toggle="tab" role="tab" aria-controls="land" aria-selected="false">Land</a>
        </li>
        <li class=" nav-item">
          <a class="nav-link" href="#misc" data-toggle="tab" role="tab" aria-controls="misc" aria-selected="false">Misc.</a>
        </li>

      </ul>

      <form [formGroup]="addWellFrm" style="width:100%;max-height:90%;overflow-x:hidden;"  (change)="hasChanged()" (ngSubmit)="createWell()">

        <div class="tab-content " id="myTabContent">
          <!--///////////////////////////////////////////////////////////////////
        basic-->
          <div class="tab-pane cp-tab-panel fade show active in topBuffer10" role="tabpanel" aria-labelledby="basic-tab" id="basic">
            <div class="row">
              <div class="form-group col-md-6">
                <label *ngIf="mode.toString() == 'createMode' || mode == 1" for="date1" class="">Create data for this well starting on: <span class="text-danger">* </span><small *ngIf="hideChangedIndicator('EffectiveDate')" class="text-muted">Changed</small></label>
                <label *ngIf="mode.toString() == 'editMode' || mode == 0" class="">Edited Effective Timeline Start Date <span class="text-danger">* </span><small *ngIf="hideChangedIndicator('EffectiveDate')" class="text-muted">Changed</small></label>
                <div>
                  <p-calendar id="mydate" formControlName="EffectiveDate" (onShow)="onCalendarOpen()" [minDate]="dateSelectOptions.minDate" [maxDate]="dateSelectOptions.maxDate" [showIcon]="true" [iconDisplay]="'input'" required></p-calendar>
                </div>
                <div class="alert alert-danger" role="alert" *ngIf=" addWellFrm.controls['EffectiveDate'].dirty &&  addWellFrm.controls['EffectiveDate'].value == null ">
                  Please select a valid effective date.
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="orgStartDate" class="float-left">Current Timeline Entry Start Date </label>
                <input name="orgStartDate" class="form-control" disabled type="text" autocomplete="off" value="{{orginialStartDate}} " />
              </div>
              <div class="col-md-6">
                <label for="statusID" class="float-left">Status <span class="text-danger">* </span><small *ngIf="hideChangedIndicator('statusID')" class="text-muted">Changed</small><small hidden id="statLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                <select name="statusID" class="form-control" id="status" (change)="statusChanged()" formControlName="statusID">
                  <option *ngIf="null == addWellFrm.controls['statusID'].value" [value]="null" selected [selected]="null == addWellFrm.controls['statusID'].value">Make a selection</option>
                  <option *ngFor="let stat of wellStatus" [value]="stat.id">
                    {{stat.name}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group" *ngIf="(hideChangedIndicator('statusID') || null != cloneSelection) &&
                 addWellFrm.controls['statusID'].value == '1' &&
                 addWellFrm.controls['EffectiveDate'].valid &&
                 null != addWellFrm.controls['EffectiveDate'].value &&
                 checkDate() &&
                 checkEffectiveDate30Days() &&
                 null != addWellFrm.controls['statusID'].value">
              <div class="alert alert-warning d-flex align-items-center">
                <h6 class="pr-4" [hidden]="checkMode('editMode')"><strong>Create placeholder data from effective date to today</strong></h6>
                <div [hidden]="checkMode('createMode')">
                  <h6 class="pr-4" [hidden]="fieldDateRangeEndString != 'n/a'"><strong>Create placeholder data from effective date to today</strong></h6>
                  <h6 class="pr-4" [hidden]="fieldDateRangeEndString == 'n/a'"><strong>No available dates for creation</strong></h6>
                </div>

                <input type="checkbox" class="big-checkbox" formControlName="hydrate" name="hydrateCheck" />

              </div>
            </div>
            <div class="form-group" *ngIf=" (mode.toString() != 'createMode' && mode != 1) &&
                 hideChangedIndicator('statusID') &&
                 addWellFrm.controls['statusID'].value != '1' &&
                 addWellFrm.controls['statusID'].value != '6' &&
                 addWellFrm.controls['EffectiveDate'].valid &&
                 null != addWellFrm.controls['EffectiveDate'].value &&
                 checkDate() &&
                 checkEffectiveDate30Days() &&
                 null != addWellFrm.controls['statusID'].value">
              <div class="alert alert-warning d-flex align-items-center">
                <h6 class="pr-4"><strong>Delete data from effective date to today</strong></h6>
                <input type="checkbox" class="big-checkbox" formControlName="hydrate" name="hydrateCheck" />
              </div>
            </div>

            <div class="form-group">
              <label for="wellName" class="float-left" *ngIf="mode.toString() == 'createMode' || mode == 1">New Well Name <span *ngIf="mode.toString() == 'createMode' || mode == 1" class="text-danger">* </span><small *ngIf="hideChangedIndicator('wellName')" class="text-muted">Changed</small><small hidden id="wellNameLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
              <label for="wellName" class="float-left" *ngIf="mode.toString() == 'editMode' || mode == 0">Well Name <span *ngIf="mode.toString() == 'editMode' || mode == 0" class="text-danger">* </span><small *ngIf="hideChangedIndicator('wellName')" class="text-muted">Changed</small><small hidden id="wellNameLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
              <input name="wellName" class="form-control" maxlength="255"  [disabled]="mode.toString() == 'editMode' || mode == 0" type="text" autocomplete="off" formControlName="wellName" />
              <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['wellName'].invalid && addWellFrm.controls['wellName'].dirty && mode.toString() != 'editMode' && mode != 0 && checkNameExistInField(addWellFrm.controls['wellName'].value)">
                Please make sure to enter a new well name. This name already exists in this field.
              </div>
            </div>

            <div class="form-group">
              <label for="fieldID" class="float-left">Field <span *ngIf="mode.toString() == 'createMode' || mode == 1" class="text-danger">* </span><small *ngIf="hideChangedIndicator('fieldID')" class="text-muted">Changed</small><small id="fieldLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
              <select name="fieldID" class="form-control" [disabled]="mode.toString() == 'editMode' || mode == 0" (change)="fieldChanged(true)" id="field" formControlName="fieldID">
                <option [value]="null" selected [selected]="null == addWellFrm.controls['fieldID'].value">Make a selection</option>
                <option *ngFor="let f of fields" [value]="f.fieldID">
                  {{f.fieldName}}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="batteryID" class="float-left">Battery <span *ngIf="addWellFrm.controls['statusID'].value != '6' && null != addWellFrm.controls['statusID'].value " class="text-danger">* </span> <small *ngIf="hideChangedIndicator('batteryID')" class="text-muted">Changed</small><small hidden id="battLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
              <select name="batteryID" class="form-control" id="battery" formControlName="batteryID">
                <option [value]="null" selected [selected]="null == addWellFrm.controls['batteryID'].value">None</option>
                <option *ngFor="let batt of fieldBatteries" [value]="batt.batteryID">
                  {{batt.batteryName}}
                </option>
              </select>
              <div class="form-group alert alert-danger" role="alert" *ngIf="addWellFrm.controls['statusID'].value != '6' && null != addWellFrm.controls['statusID'].value && (null == addWellFrm.controls['batteryID'].value || 0 == addWellFrm.controls['batteryID'].value)">
                Battery cannot be none while a non-drilling status is selected.
              </div>
            </div>

            <div class="form-group">
              <label for="apiNumber" class="float-left">API Number <small *ngIf="hideChangedIndicator('apiNumber')" class="text-muted">Changed</small></label>
              <input name="apiNumber" class="form-control" type="text" autocomplete="off" formControlName="apiNumber" />
              <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['apiNumber'].invalid">
                {{invalidAPIMessage}}
              </div>
            </div>

            <div class="form-group">
              <label for="notes" class="float-left">Notes ({{addWellFrm.controls['notes'].value.length}}/255) <small *ngIf="hideChangedIndicator('notes')" class="text-muted">Changed</small></label>
              <textarea name="notes" class="form-control" autocomplete="off" maxlength="255" formControlName="notes"></textarea>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body d-flex align-items-center flex-wrap">
                    <h6 class="pr-4"><strong>Gas Lift Well</strong></h6>
                    <label class="switch">
                      <input type="checkbox" id="GasLiftWellSlider" formControlName="isGasLiftWell">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body d-flex align-items-center flex-wrap">
                    <h6 class="pr-4"><strong>Injection Well</strong></h6>
                    <label class="switch">
                      <input type="checkbox" id="InjectionWellSlider" (change)="injectionWellChange()" formControlName="injectionWell">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

          </div>
              <!--///////////////////////////////////////////////////////////////////
    reg-->

          <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="reg-tab" id="reg" style="width:98%;">

            <div class="form-group">
              <label for="regFieldName" class="float-left">Field Name <small *ngIf="hideChangedIndicator('regFieldName')" class="text-muted">Changed</small></label>
              <input name="regFieldName" class="form-control" type="text" autocomplete="off" formControlName="regFieldName" maxlength="50" />
            </div>

            <div class="form-group">
              <label for="regFieldCode" class="float-left">Field Code <small *ngIf="hideChangedIndicator('regFieldCode')" class="text-muted">Changed</small></label>
              <input name="regFieldCode" class="form-control" type="text" autocomplete="off" formControlName="regFieldCode" maxlength="50" />
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regLeaseName" class="float-left">Lease Name <small *ngIf="hideChangedIndicator('regLeaseName')" class="text-muted">Changed</small></label>
                <input name="regLeaseName" class="form-control" type="text" autocomplete="off" formControlName="regLeaseName" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="leaseNumber" class="float-left">Lease #<small *ngIf="hideChangedIndicator('leaseNumber')" class="text-muted">Changed</small></label>
                <input name="leaseNumber" class="form-control" type="text" autocomplete="off" formControlName="leaseNumber" maxlength="50" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="serialNumber" class="float-left">Serial # <small *ngIf="hideChangedIndicator('serialNumber')" class="text-muted">Changed</small></label>
                <input name="serialNumber" class="form-control" type="text" autocomplete="off" formControlName="serialNumber" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regWellNumber" class="float-left">Well Number <small *ngIf="hideChangedIndicator('regWellNumber')" class="text-muted">Changed</small></label>
                <input name="regWellNumber" class="form-control" type="text" autocomplete="off" formControlName="regWellNumber" maxlength="50" />

              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regDrillPermit" class="float-left">Permit #<small *ngIf="hideChangedIndicator('regDrillPermit')" class="text-muted">Changed</small></label>
                <input name="regDrillPermit" class="form-control" type="text" autocomplete="off" formControlName="regDrillPermit" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regCommPermit" class="float-left">Commingle Permit # <small *ngIf="hideChangedIndicator('regCommPermit')" class="text-muted">Changed</small></label>
                <input name="regCommPermit" class="form-control" type="text" autocomplete="off" formControlName="regCommPermit" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regWellStatus" class="float-left">Reg Well Status <small *ngIf="hideChangedIndicator('regWellStatus')" class="text-muted">Changed</small></label>
                <select name="regWellStatus" class="form-control" id="regWellStatus" formControlName="regWellStatus">
                  <option [value]="null" selected [selected]="null == addWellFrm.controls['regWellStatus'].value">Make a selection</option>
                  <option *ngFor="let regwellstat of regWellStatus" [value]="regwellstat.entryID">
                    {{regwellstat.alias}}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="regWellTypeID" class="float-left">Reg Well Type <small *ngIf="hideChangedIndicator('regWellTypeID')" class="text-muted">Changed</small></label>
                <select name="regWellTypeID" class="form-control" id="regWellTypeID" formControlName="regWellTypeID">
                  <option [value]="null" selected [selected]="null == addWellFrm.controls['regWellTypeID'].value">Make a selection</option>
                  <option *ngFor="let regWellType of regWellTypeID" [value]="regWellType.entryID">
                    {{regWellType.alias}}
                  </option>
                </select>
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="operatorName" class="float-left">Operator <small *ngIf="hideChangedIndicator('operatorName')" class="text-muted">Changed</small></label>
                <input name="operatorName" class="form-control" type="text" autocomplete="off" formControlName="operatorName" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regOperCode" class="float-left">Operator Code <small *ngIf="hideChangedIndicator('regOperCode')" class="text-muted">Changed</small></label>
                <input name="regOperCode" class="form-control" type="text" autocomplete="off" formControlName="regOperCode" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regState" class="float-left">State <small *ngIf="hideChangedIndicator('regState')" class="text-muted">Changed</small></label>
                <select name="regState" class="form-control" id="regState" formControlName="regState">
                  <option [value]="null" selected [selected]="null == addWellFrm.controls['regState'].value">Make a selection</option>
                  <option [value]="'AL'">Alabama</option>
                  <option [value]="'AK'">Alaska</option>
                  <option [value]="'AZ'">Arizona</option>
                  <option [value]="'AR'">Arkansas</option>
                  <option [value]="'CA'">California</option>
                  <option [value]="'CO'">Colorado</option>
                  <option [value]="'CT'">Connecticut</option>
                  <option [value]="'DE'">Delaware</option>
                  <option [value]="'DC'">District Of Columbia</option>
                  <option [value]="'FL'">Florida</option>
                  <option [value]="'GA'">Georgia</option>
                  <option [value]="'HI'">Hawaii</option>
                  <option [value]="'ID'">Idaho</option>
                  <option [value]="'IL'">Illinois</option>
                  <option [value]="'IN'">Indiana</option>
                  <option [value]="'IA'">Iowa</option>
                  <option [value]="'KS'">Kansas</option>
                  <option [value]="'KY'">Kentucky</option>
                  <option [value]="'LA'">Louisiana</option>
                  <option [value]="'ME'">Maine</option>
                  <option [value]="'MD'">Maryland</option>
                  <option [value]="'MA'">Massachusetts</option>
                  <option [value]="'MI'">Michigan</option>
                  <option [value]="'MN'">Minnesota</option>
                  <option [value]="'MS'">Mississippi</option>
                  <option [value]="'MO'">Missouri</option>
                  <option [value]="'MT'">Montana</option>
                  <option [value]="'NE'">Nebraska</option>
                  <option [value]="'NV'">Nevada</option>
                  <option [value]="'NH'">New Hampshire</option>
                  <option [value]="'NJ'">New Jersey</option>
                  <option [value]="'NM'">New Mexico</option>
                  <option [value]="'NY'">New York</option>
                  <option [value]="'NC'">North Carolina</option>
                  <option [value]="'ND'">North Dakota</option>
                  <option [value]="'OH'">Ohio</option>
                  <option [value]="'OK'">Oklahoma</option>
                  <option [value]="'OR'">Oregon</option>
                  <option [value]="'PA'">Pennsylvania</option>
                  <option [value]="'RI'">Rhode Island</option>
                  <option [value]="'SC'">South Carolina</option>
                  <option [value]="'SD'">South Dakota</option>
                  <option [value]="'TN'">Tennessee</option>
                  <option [value]="'TX'">Texas</option>
                  <option [value]="'UT'">Utah</option>
                  <option [value]="'VT'">Vermont</option>
                  <option [value]="'VA'">Virginia</option>
                  <option [value]="'WA'">Washington</option>
                  <option [value]="'WV'">West Virginia</option>
                  <option [value]="'WI'">Wisconsin</option>
                  <option [value]="'WY'">Wyoming</option>
                </select>
              </div>
              <div class="col-md-6">
                <label for="isOperated" >Is current company the operator? <small *ngIf="hideChangedIndicator('isOperated')" class="text-muted">Changed</small></label>
                <div>
                  <label class="pr-4 radio-inline"><input type="radio" id="OperatedRadio" formControlName="isOperated" [value]="true" /> Yes</label>
                  <label class="pr-4 radio-inline "><input type="radio" id="NonOperatedRadio" formControlName="isOperated" [value]="false" /> No</label>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regCounty" class="float-left">County/Parish <small *ngIf="hideChangedIndicator('regCounty')" class="text-muted">Changed</small></label>
                <input name="regCounty" class="form-control" type="text" autocomplete="off" formControlName="regCounty" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regParishCode" class="float-left">Parish Code <small *ngIf="hideChangedIndicator('regParishCode')" class="text-muted">Changed</small></label>
                <input name="regParishCode" class="form-control" type="text" autocomplete="off" formControlName="regParishCode" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regDistrict" class="float-left">District <small *ngIf="hideChangedIndicator('regDistrict')" class="text-muted">Changed</small></label>
                <input name="regDistrict" class="form-control" type="text" autocomplete="off" formControlName="regDistrict" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regSection" class="float-left">Section <small *ngIf="hideChangedIndicator('regSection')" class="text-muted">Changed</small></label>
                <input name="regSection" class="form-control" type="text" autocomplete="off" formControlName="regSection" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">

              <div class="col-md-6">
                <label for="regTownship" class="float-left">Township <small *ngIf="hideChangedIndicator('regTownship')" class="text-muted">Changed</small></label>
                <input name="regTownship" class="form-control" type="text" autocomplete="off" formControlName="regTownship" maxlength="50" />
              </div>

              <div class="col-md-6">
                <label for="regRange" class="float-left">Range <small *ngIf="hideChangedIndicator('regRange')" class="text-muted">Changed</small></label>
                <input name="regRange" class="form-control" type="text" autocomplete="off" formControlName="regRange" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regPool" class="float-left">Pool <small *ngIf="hideChangedIndicator('regPool')" class="text-muted">Changed</small></label>
                <input name="regPool" class="form-control" type="text" autocomplete="off" formControlName="regPool" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regMeridian" class="float-left">Meridian <small *ngIf="hideChangedIndicator('regMeridian')" class="text-muted">Changed</small></label>
                <input name="regMeridian" class="form-control" type="text" autocomplete="off" formControlName="regMeridian" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regClass" class="float-left">Class <small *ngIf="hideChangedIndicator('regClass')" class="text-muted">Changed</small></label>
                <input name="regClass" class="form-control" type="text" autocomplete="off" formControlName="regClass" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regSubClass" class="float-left">Sub Class <small *ngIf="hideChangedIndicator('regSubClass')" class="text-muted">Changed</small></label>
                <input name="regSubClass" class="form-control" type="text" autocomplete="off" formControlName="regSubClass" maxlength="50" />
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label for="regFacilityCode" class="float-left">Facility Code <small *ngIf="hideChangedIndicator('regFacilityCode')" class="text-muted">Changed</small></label>
                <input name="regFacilityCode" class="form-control" type="text" autocomplete="off" formControlName="regFacilityCode" maxlength="50" />
              </div>
              <div class="col-md-6">
                <label for="regTransporterCode" class="float-left">Transporter Code <small *ngIf="hideChangedIndicator('regTransporterCode')" class="text-muted">Changed</small></label>
                <input name="regTransporterCode" class="form-control" type="text" autocomplete="off" formControlName="regTransporterCode" maxlength="50" />
              </div>

            </div>

          </div>

              <!--///////////////////////////////////////////////////////////////////
    gas-->

              <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="gas-tab" id="gas" style="width:98%;">

                <div class="form-group">
                  <label for="gasFacilityID" class="float-left">Gas Facility <small *ngIf="hideChangedIndicator('gasFacilityID')" class="text-muted">Changed</small><small hidden id="gasLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                  <select name="gasFacilityID" class="form-control" id="gasFacilityID" formControlName="gasFacilityID">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['gasFacilityID'].value">Make a selection</option>
                    <option *ngFor="let f of fieldGasFacilities" [value]="f.gasFacilityID">
                      {{f.gasFacilityName}}
                    </option>
                  </select>

                </div>

                <div class="form-group">

                  <label for="mmbtUperMCF" class="float-left">MMBTU/MCF <small *ngIf="hideChangedIndicator('mmbtUperMCF')" class="text-muted">Changed</small></label>
                  <input name="mmbtUperMCF" class="form-control" type="text" autocomplete="off" formControlName="mmbtUperMCF" />
                  <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['mmbtUperMCF'].invalid && addWellFrm.controls['injectionWell'].value == false">
                    {{invalidFloatMessage}}
                  </div>

                </div>

                <div class="card mb-4">
                  <div class="card-header">
                    Wellhead
                  </div>
                  <div class="card-body">
                    <div class="form-group row">
                      <div class="col-md-3">
                        <label for="gasOutMeterDiameter" class="float-left">Meter Diameter <small *ngIf="hideChangedIndicator('gasOutMeterDiameter')" class="text-muted">Changed</small><small hidden id="gasOutDiameterLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                        <select name="gasOutMeterDiameter" class="form-control" id="gasOutMeterDiameter" (change)="setPlateDiameterDropDown(addWellFrm.controls['gasOutMeterDiameter'].value, false,false)" formControlName="gasOutMeterDiameter">
                          <option [value]="null" selected [selected]="null == addWellFrm.controls['gasOutMeterDiameter'].value">Make a selection</option>
                          <option *ngFor="let p of wellPlateInfo" [value]="p.plateDiameter">
                            {{p.plateDiameter}}
                          </option>
                        </select>
                        <div role="alert" class="alert alert-danger" *ngIf="null != addWellFrm.controls['gasOutMeterDiameter'].value && null == addWellFrm.controls['gasOutPlateSize'].value && !addWellFrm.controls['injectionWell'].value">
                          Please select a Wellhead Gas Meter Plate Size
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="gasOutPlateSize" class="float-left">Meter Plate Size <small *ngIf="hideChangedIndicator('gasOutPlateSize')" class="text-muted">Changed</small><small hidden id="gasOutPlateLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                        <select name="gasOutPlateSize" class="form-control" id="gasOutPlateSize" (change)="setPlateSizeCoef(addWellFrm.controls['gasOutMeterDiameter'].value ,addWellFrm.controls['gasOutPlateSize'].value, false)" formControlName="gasOutPlateSize">
                          <option [value]="null" [selected]="null == addWellFrm.controls['gasOutPlateSize'].value">Make a selection</option>
                          <option *ngFor="let i of gasOutPlateSize" [value]=" i.plateSize">
                            {{i.plateSize}}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="gasOutPlateCoefficient" class="float-left">Plate Coefficient <small *ngIf="hideChangedIndicator('gasOutPlateCoefficient')" class="text-muted">Changed</small><small hidden id="gasOutPlateCoefLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                          <input name="gasOutPlateCoefficient" class="form-control" formControlName="gasOutPlateCoefficient" disabled />
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="gasOutSpringSize" class="float-left">Spring Size <small *ngIf="hideChangedIndicator('gasOutSpringSize')" class="text-muted">Changed</small></label>
                        <input name="gasOutSpringSize" class="form-control" type="text" autocomplete="off" formControlName="gasOutSpringSize" />
                        <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['gasOutSpringSize'].invalid && !addWellFrm.controls['injectionWell'].value ">
                          {{invalidFloatMessage}}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header">
                    Injection
                  </div>
                  <div class="card-body">
                    <div class="form-group row">
                      <div class="col-md-3">
                        <label for="gasInMeterDiameter" class="float-left">Meter Diameter <small *ngIf="hideChangedIndicator('gasInMeterDiameter')" class="text-muted">Changed</small><small hidden id="gasInDiameterLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                        <select name="gasInMeterDiameter" class="form-control" id="gasInMeterDiameter" (change)="setPlateDiameterDropDown(addWellFrm.controls['gasInMeterDiameter'].value, true,false)" formControlName="gasInMeterDiameter">
                          <option [value]="null" selected [selected]="null == addWellFrm.controls['gasInMeterDiameter'].value">Make a selection</option>
                          <option *ngFor="let t of wellPlateInfo" [value]="t.plateDiameter">
                            {{t.plateDiameter}}
                          </option>
                        </select>
                        <div role="alert" class="alert alert-danger" *ngIf="null != addWellFrm.controls['gasInMeterDiameter'].value && null == addWellFrm.controls['gasInPlateSize'].value && !addWellFrm.controls['injectionWell'].value">
                          Please select an Injection Gas Meter Plate Size
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="gasInPlateSize" class="float-left">Meter Plate Size <small *ngIf="hideChangedIndicator('gasInPlateSize')" class="text-muted">Changed</small><small hidden id="gasInPlateLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                        <select name="gasInPlateSize" class="form-control" id="gasInPlateSize" (change)="setPlateSizeCoef(addWellFrm.controls['gasInMeterDiameter'].value,addWellFrm.controls['gasInPlateSize'].value, true)" formControlName="gasInPlateSize">
                          <option [value]="null" selected [selected]="null == addWellFrm.controls['gasInPlateSize'].value">Make a selection</option>
                          <option *ngFor="let g of gasInPlateSize" [value]="g.plateSize">
                            {{g.plateSize}}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label for="plateInSizeCoef" class="float-left">Plate Coefficient <small *ngIf="hideChangedIndicator('gasInPlateCoefficient')" class="text-muted">Changed</small><small hidden id="gasInPlateCoefLoader"><span class="spinner-border spinner-border-sm"></span></small> </label>
                        <input name="plateInSizeCoef" class="form-control" formControlName="gasInPlateCoefficient" disabled />
                      </div>

                      <div class="col-md-3">
                        <label for="gasInSpringSize" class="float-left"> Spring Size <small *ngIf="hideChangedIndicator('gasInSpringSize')" class="text-muted">Changed</small></label>
                        <input name="gasInSpringSize" class="form-control" type="text" autocomplete="off" formControlName="gasInSpringSize" />
                        <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['gasInSpringSize'].invalid && !addWellFrm.controls['injectionWell'].value">
                          {{invalidFloatMessage}}
                        </div>
                      </div>


                    </div>
                  </div>
                </div>


              </div>

              <!--///////////////////////////////////////////////////////////////////
    swd-->

              <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="swd-tab" id="swd" style="width:98%;">

                <div class="form-group">
                  <label for="swdID" class="float-left">SWD <small *ngIf="hideChangedIndicator('swdid')" class="text-muted">Changed</small></label>
                  <select name="swdID" class="form-control" id="swdID" formControlName="swdid">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['swdid'].value">Make a selection</option>
                    <option *ngFor="let swd of swdID" [value]="swd.wellID" [disabled]="disableSWDEntry(swd.wellID, swd.wellName)">
                      {{swd.wellName}}
                    </option>
                  </select>
                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="swdMaxPSI" class="float-left">Max SWD Pressure (psi) <small *ngIf="hideChangedIndicator('swdMaxPSI')" class="text-muted">Changed</small></label>
                    <input name="swdMaxPSI" class="form-control" type="text" autocomplete="off" formControlName="swdMaxPSI" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['swdMaxPSI'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="swdMaxRate" class="float-left">Max SWD Rate <small *ngIf="hideChangedIndicator('swdMaxRate')" class="text-muted">Changed</small></label>
                    <input name="swdMaxRate" class="form-control" type="text" autocomplete="off" formControlName="swdMaxRate" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['swdMaxRate'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>

                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="swdIntervalTop" class="float-left">SWD Top Interval <small *ngIf="hideChangedIndicator('swdIntervalTop')" class="text-muted">Changed</small></label>
                    <input name="swdIntervalTop" class="form-control" type="text" autocomplete="off" formControlName="swdIntervalTop" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['swdIntervalTop'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="swdIntervalBottom" class="float-left">SWD Bottom Interval <small *ngIf="hideChangedIndicator('swdIntervalBottom')" class="text-muted">Changed</small></label>
                    <input name="swdIntervalBottom" class="form-control" type="text" autocomplete="off" formControlName="swdIntervalBottom" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['swdIntervalBottom'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                </div>

              </div>

              <!--///////////////////////////////////////////////////////////////////
    completion-->

              <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="completion-tab" id="completion" style="width:98%;">

                <div class="form-group ">
                  <div class="row">
                    <label for="radioDiv" style="margin-left:15px;" class="control-label float-left">Directional Flag <small *ngIf="hideChangedIndicator('directionalFlag')" class="text-muted">Changed</small></label>
                  </div>
                  <div class="form-control" id="radioDiv" name="radioDiv">
                    <label class="pr-4 radio-inline"><input checked [checked]="addWellFrm.controls['directionalFlag'].value == 'v'" type="radio" id="v" formControlName="directionalFlag" value="v" /> Vertical</label>
                    <label class="pr-4 radio-inline "><input [checked]="addWellFrm.controls['directionalFlag'].value == 'h'" type="radio" id="h" formControlName="directionalFlag" value="h" /> Horizontal</label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="reservoirName" class="float-left">Reservoir <small *ngIf="hideChangedIndicator('reservoirName')" class="text-muted">Changed</small></label>
                  <input name="reservoirName" class="form-control" type="text" autocomplete="off" formControlName="reservoirName" />
                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="totalVerticalDepth" class="float-left">Total Vertical Depth <small *ngIf="hideChangedIndicator('totalVerticalDepth')" class="text-muted">Changed</small></label>
                    <input name="totalVerticalDepth" class="form-control" type="text" autocomplete="off" formControlName="totalVerticalDepth" />
                    <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['totalVerticalDepth'].invalid">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="measuredDepth" class="float-left">Measured Depth <small *ngIf="hideChangedIndicator('measuredDepth')" class="text-muted">Changed</small></label>
                    <input name="measuredDepth" class="form-control" type="text" autocomplete="off" formControlName="measuredDepth" />
                    <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['measuredDepth'].invalid">
                      {{invalidFloatMessage}}
                    </div>
                  </div>

                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="subSeaDepth" class="float-left">Sub Sea Depth <small *ngIf="hideChangedIndicator('subSeaDepth')" class="text-muted">Changed</small></label>
                    <input name="subSeaDepth" class="form-control" type="text" autocomplete="off" formControlName="subSeaDepth" />
                    <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['subSeaDepth'].invalid">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="referenceElevation" class="float-left">Reference Elevation <small *ngIf="hideChangedIndicator('referenceElevation')" class="text-muted">Changed</small></label>
                    <input name="referenceElevation" class="form-control" type="text" autocomplete="off" formControlName="referenceElevation" />
                    <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['referenceElevation'].invalid">
                      {{invalidFloatMessage}}
                    </div>
                  </div>

                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="packerDepth" class="float-left">Packer Depth <small *ngIf="hideChangedIndicator('packerDepth')" class="text-muted">Changed</small></label>
                    <input name="packerDepth" class="form-control" type="text" autocomplete="off" formControlName="packerDepth" />
                    <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['packerDepth'].invalid">
                      {{invalidNumMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="plugBackDepth" class="float-left">Plug Back Depth <small *ngIf="hideChangedIndicator('plugBackDepth')" class="text-muted">Changed</small></label>
                    <input name="plugBackDepth" class="form-control" type="text" autocomplete="off" formControlName="plugBackDepth" />
                    <div class="alert alert-danger" role="alert" *ngIf="addWellFrm.controls['plugBackDepth'].invalid">
                      {{invalidFloatMessage}}
                    </div>
                  </div>

                </div>

              </div>

              <!--///////////////////////////////////////////////////////////////////
    interests-->

              <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="interests-tab" id="interests" style="width:98%;">

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="nrioil" class="float-left">Oil NRI <small *ngIf="hideChangedIndicator('nrioil')" class="text-muted">Changed</small></label>
                    <input name="nrioil" class="form-control" type="text" autocomplete="off" formControlName="nrioil" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['nrioil'].invalid && !addWellFrm.controls['injectionWell'].value">
                      {{invalidPercentageMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="nrigas" class="float-left">Gas NRI <small *ngIf="hideChangedIndicator('nrigas')" class="text-muted">Changed</small></label>
                    <input name="nrigas" class="form-control" type="text" autocomplete="off" formControlName="nrigas" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['nrigas'].invalid && !addWellFrm.controls['injectionWell'].value">
                      {{invalidPercentageMessage}}
                    </div>
                  </div>
                </div>



                <div class="form-group row">

                  <div class="col-md-6">
                    <label for="nwioil" class="float-left">Oil NWI <small *ngIf="hideChangedIndicator('nwioil')" class="text-muted">Changed</small></label>
                    <input name="nwioil" class="form-control" type="text" autocomplete="off" formControlName="nwioil" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['nwioil'].invalid && !addWellFrm.controls['injectionWell'].value">
                      {{invalidPercentageMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="nwigas" class="float-left">Gas NWI <small *ngIf="hideChangedIndicator('nwigas')" class="text-muted">Changed</small></label>
                    <input name="nwigas" class="form-control" type="text" autocomplete="off" formControlName="nwigas" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['nwigas'].invalid && !addWellFrm.controls['injectionWell'].value">
                      {{invalidPercentageMessage}}
                    </div>
                  </div>

                </div>
              </div>

              <!--///////////////////////////////////////////////////////////////////
    land-->
              <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="land-tab" id="land" style="width:98%;">

                <div class="form-group">
                  <label for="landPropertyID" class="float-left">Land Property<small *ngIf="hideChangedIndicator('landPropertyID')" class="text-muted">Changed</small></label>
                  <select name="landPropertyID" class="form-control" id="landPropertyID" formControlName="landPropertyID">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['landPropertyID'].value">Make a selection</option>
                    <option *ngFor="let lp of landPropertyID" [value]="lp.landPropertyID">
                      {{lp.landPropertyName}}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="landUnitFK" class="float-left">Land Unit <small *ngIf="hideChangedIndicator('landUnitFK')" class="text-muted">Changed</small></label>
                  <select name="landUnitFK" class="form-control" id="landUnitFK" formControlName="landUnitFK">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['landUnitFK'].value">Make a selection</option>
                    <option *ngFor="let lu of landUnits" [value]="lu.id">
                      {{lu.landUnitName}}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="landLeaseFK" class="float-left">Land Lease <small *ngIf="hideChangedIndicator('landLeaseFK')" class="text-muted">Changed</small></label>
                  <select name="landLeaseFK" class="form-control" id="landLeaseFK" formControlName="landLeaseFK">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['landLeaseFK'].value">Make a selection</option>
                    <option *ngFor="let ll of landLeases" [value]="ll.id">
                      {{ll.landLeaseName}}
                    </option>
                  </select>
                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="wellLandWaterTypeID" class="float-left">Land Water Type <small *ngIf="hideChangedIndicator('wellLandWaterTypeID')" class="text-muted">Changed</small></label>
                    <select name="wellLandWaterTypeID" class="form-control" id="wellLandWaterTypeID" formControlName="wellLandWaterTypeID">
                      <option [value]="null" selected [selected]="null == addWellFrm.controls['wellLandWaterTypeID'].value">Make a selection</option>
                      <option *ngFor="let wellLandType of wellLandWaterTypeID" [value]="wellLandType.entryID">
                        {{wellLandType.alias}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="wellSingleDualTypeID" class="float-left">Single Dual Type <small *ngIf="hideChangedIndicator('wellSingleDualTypeID')" class="text-muted">Changed</small></label>
                    <select name="wellSingleDualTypeID" class="form-control" id="wellSingleDualTypeID" formControlName="wellSingleDualTypeID">
                      <option [value]="null" selected [selected]="null == addWellFrm.controls['wellSingleDualTypeID'].value">Make a selection</option>
                      <option *ngFor="let wellSingleDual of wellSingleDualTypeID" [value]="wellSingleDual.entryID">
                        {{wellSingleDual.alias}}
                      </option>
                    </select>
                  </div>

                </div>

              </div>

              <!--///////////////////////////////////////////////////////////////////
    misc-->

              <div class="tab-pane  cp-tab-panel fade topBuffer10" role="tabpanel" aria-labelledby="misc-tab" id="misc" style="width:98%;">

                <div class="form-group">
                  <label for="injectionMethodID" class="float-left">Injection Method <small *ngIf="hideChangedIndicator('injectionMethodID')" class="text-muted">Changed</small></label>
                  <select name="injectionMethodID" class="form-control" id="injectionMethodID" formControlName="injectionMethodID">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['injectionMethodID'].value">Make a selection</option>
                    <option *ngFor="let im of injectionMethodID" [value]="im.entryID">
                      {{im.alias}}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="skimTankID" class="float-left">Skim Tank <small *ngIf="hideChangedIndicator('skimTankID')" class="text-muted">Changed</small><small hidden id="skimTankLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                  <select name="skimTankID" class="form-control" id="skimTankID" formControlName="skimTankID">
                    <option [value]="null" selected [selected]="null == addWellFrm.controls['skimTankID'].value">Make a selection</option>
                    <option *ngFor="let f of skimTanks" [value]="f.skimTankID">
                      {{f.gasFacilityName}}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="masip" class="float-left">Max Shutin Pressure <small *ngIf="hideChangedIndicator('masip')" class="text-muted">Changed</small></label>
                  <input name="masip" class="form-control" type="text" autocomplete="off" formControlName="masip" />
                  <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['masip'].invalid ">
                    {{invalidFloatMessage}}
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="valve1PSC" class="float-left">Valve PSC <small *ngIf="hideChangedIndicator('valve1PSC')" class="text-muted">Changed</small></label>
                    <input name="valve1PSC" class="form-control" type="text" autocomplete="off" formControlName="valve1PSC" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['valve1PSC'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="pumpbore" class="float-left">Pump Bore <small *ngIf="hideChangedIndicator('pumpbore')" class="text-muted">Changed</small></label>
                    <input name="pumpbore" class="form-control" type="text" autocomplete="off" formControlName="pumpbore" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['pumpbore'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>

                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="lat" class="float-left">Latitude <small *ngIf="hideChangedIndicator('lat')" class="text-muted">Changed</small></label>
                    <input name="lat" class="form-control" type="text" autocomplete="off" formControlName="lat" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['lat'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="lon" class="float-left">Longitude <small *ngIf="hideChangedIndicator('lon')" class="text-muted">Changed</small></label>
                    <input name="lon" class="form-control" type="text" autocomplete="off" formControlName="lon" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['lon'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>

                </div>



                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="xcoord" class="float-left">X Coordinate <small *ngIf="hideChangedIndicator('xcoord')" class="text-muted">Changed</small></label>
                    <input name="xcoord" class="form-control" type="text" autocomplete="off" formControlName="xcoord" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['xcoord'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="ycoord" class="float-left">Y Coordinate <small *ngIf="hideChangedIndicator('ycoord')" class="text-muted">Changed</small></label>
                    <input name="ycoord" class="form-control" type="text" autocomplete="off" formControlName="ycoord" />
                    <div role="alert" class="alert alert-danger" *ngIf="addWellFrm.controls['ycoord'].invalid ">
                      {{invalidFloatMessage}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////-->
        <div class="modal-footer" style="justify-content:flex-start">
          <div class="loading-indicator login-btn-container" *ngIf="!submitted">
            <button type="submit" class="btn btn-primary" [hidden]="checkMode('editMode')" [disabled]="addWellFrm.invalid || addWellFrm.pristine || isFormInvalid() || validPlateSize() || requiredNotLoaded ">Create Well</button>

            <button type="submit" class="btn btn-primary" [hidden]="checkMode('createMode')" [disabled]="addWellFrm.invalid || addWellFrm.pristine || isFormInvalid() || validPlateSize() || requiredNotLoaded || !atLeastOneDirty">Save Timeline Entry</button><!--Create Well-->
          </div>
          <div class="loading-indicator login-btn-container" *ngIf="submitted">
            <button class="btn  btn-danger"><span class="spinner-border spinner-border-sm"></span> Submitting...</button>
          </div>
          <div>
            <button type="button" class="btn btn-secondary pull-left" id="CreateWellCancel" (click)="exitPage()">Cancel</button>
          </div>
        </div>
</form>
      

  <div class="container" *ngIf="!wells"><h1 class="centerText"><span class="spinner-border spinner-border-sm"></span> Loading...</h1>
  </div>
</div>
